// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `i {
  display: contents;
  margin-left: 10px;
}

ng-content {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-sortable-column/s1-sortable-column.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,iBAAA;AACF;;AACA;EACE,kBAAA;AAEF","sourcesContent":["i {\n  display: contents;\n  margin-left: 10px;\n}\nng-content {\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
